import { VideoPlayerService } from 'src/core/app/aro/components/videos/video-player-window/video-player.service';
import { AspObject } from '@core_n/asp/AspObject';
import { IMapMngr, IObjectsPool } from '@core_n/asp/interfaces';
import { SensorsCorePool } from '@core_n/asp/SensorsCorePool';
import { AppInjector } from '@core_n/common/inject';
import * as consts from '../../core/app/common/consts';
import { SoundMsgMngrService } from '../../core/app/msg/sound-msg-mngr.service';
import { AroSensorService } from '../aro/aro-sensor.service';
import * as projConsts from '../common/projConsts';
import * as projEnums from '../common/projEnums';
import { SensorBiasService } from '../sensor-bias/sensor-bias.service';
import * as enums from './../../core/app/common/enums';
import * as settings from './../../core/app/common/settings';
import { SensorObject } from './SensorObject';


export class SensorsPool extends SensorsCorePool {

  protected createSensorObject(objectsPool: IObjectsPool, sensorID: number, sensorLetter: string) {
    return new SensorObject(objectsPool, sensorID, sensorLetter);
  }

  //1011 means Center
  contextMenuActions(obj: AspObject): number[] {
    let sensor = obj as SensorObject;
    if (sensor.geometryMenuVisible)
      return [consts.USER_ACTION_UPDATE_NAT_NAI, consts.USER_ACTION_DELETE_NAT_NAI];


    if (sensor.isAcoustic)
      return [projConsts.USER_ACTION_SHOW_ARO, consts.USER_ACTION_OPEN_SOUND_PLAYER, consts.USER_ACTION_CREATE_NAT_NAI];
    else if (sensor.isVideo)
      return [projConsts.USER_ACTION_SHOW_ARO, consts.USER_ACTION_OPEN_VIDEO_PLAYER];
    else
      return [projConsts.USER_ACTION_SHOW_ARO, consts.USER_ACTION_CREATE_NAT_NAI];

  }

  handleUserAction(action: number, obj: AspObject, mapMngr: IMapMngr): boolean {
    let sensor = obj as SensorObject;

    if (action == consts.USER_ACTION_OPEN_SOUND_PLAYER) {
      AppInjector.get(SoundMsgMngrService).openSoundPlayerWindow(sensor.sensorID, sensor.name);
    }

    if (action == consts.USER_ACTION_OPEN_VIDEO_PLAYER) {
      AppInjector.get(VideoPlayerService).showVideoPlayer(sensor);
    }

    if (action == projConsts.USER_ACTION_SHOW_ARO) {
      if (sensor.geometryMenuVisible)
        AppInjector.get(SensorBiasService).showNatNai(sensor, projEnums.NatNaiOperationAction.Update);
      else {
        if (settings.userSettings.userPerm == enums.Permission.USER)
          return true;
        AppInjector.get(AroSensorService).showWindow(sensor);
        return true;
      }
    }
    if (action == projConsts.USER_ACTION_SENSOR_BIAS) {
      AppInjector.get(SensorBiasService).showSensorBias(sensor);
      return true;
    }

    if (action == consts.USER_ACTION_CREATE_NAT_NAI) {
      AppInjector.get(SensorBiasService).showNatNai(sensor, projEnums.NatNaiOperationAction.Create);
      return true;
    }

    if (action == consts.USER_ACTION_NAT_NAI_TURN_ON || action == consts.USER_ACTION_NAT_NAI_TURN_OFF) {
      sensor.isNatNaiVisible = !sensor.isNatNaiVisible;
      if (sensor.naiNatArray) {
        sensor.naiNatArray.forEach(item => {
          item.isVisible = sensor.isNatNaiVisible;
        });
      }
      sensor.notifyDataChange();
      return true;
    }

    if (action == consts.USER_ACTION_UPDATE_NAT_NAI) {
      AppInjector.get(SensorBiasService).showNatNai(sensor, projEnums.NatNaiOperationAction.Update);
      return true;
    }

    if (action == consts.USER_ACTION_DELETE_NAT_NAI) {
      AppInjector.get(SensorBiasService).showNatNai(sensor, projEnums.NatNaiOperationAction.Delete);
      return true;
    }

    // else if (action == projConsts.USER_ACTION_RESET_BIASES) {
    //   let resetBiasesMsg = new projMsgs.ResetBiasesMsg();
    //   resetBiasesMsg.systemId = sensor.sensorID;
    //   resetBiasesMsg.source = projEnums.FieldSource.Menatev;
    //   AppInjector.get(UserActionService).sendUserAction(resetBiasesMsg);
    //   return true;
    // }
    // else if (action == projConsts.USER_ACTION_UNREGISTER) {
    //   let unregisterMsg = new projMsgs.UnregisterMsg();
    //   unregisterMsg.systemId = sensor.sensorID;
    //   unregisterMsg.source = projEnums.FieldSource.Menatev;
    //   AppInjector.get(UserActionService).sendUserAction(unregisterMsg);
    //   return true;
    // }

    return super.handleUserAction(action, obj, mapMngr);
  }
}

